import styled from "styled-components";
import { COLORS, responsive } from "../../../../styles/constants.style";

export const BulkTransferStatusPanelWrapper = styled.div`
  margin-top: 30px;
  background: ${COLORS.cirrus_black1};
  border: 1px solid ${COLORS.cirrus_black3};
  border-radius: 12px;
  padding: 24px 16px;
  max-width: 600px;
  margin-inline: auto;

  display: flex;
  flex-direction: column;
  align-items: center;
  row-gap: 0;

  ${responsive.MOBILE`
    padding: 16px 12px;
    margin-inline: 43px;
    margin-top: 10px;
  `}
  .label {
    text-align: center;
  }

  .queue-buttons {
    display: flex;
    justify-content: space-between;
    width: 100%;
    padding-inline: 20px;
    ${responsive.MOBILE`
      flex-direction: column;
    `}
  }
  .label-name-value {
    max-width: 390px;
  }
`;

export const BulkActivityCardsWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 16px 0;
  width: 100%;

  ${responsive.MOBILE`
    flex-direction: column;
    align-items: stretch;
    gap: 16px;
    margin: 12px 0;
  `}
`;
export const VerticalDivider = styled.div`
  height: 70px;
  border-left: 1px dashed ${COLORS.cirrus_black4};

  ${responsive.MOBILE`
    align-self: center;
    height: 1px;
    width: 30%;
    border-left: none;
    border-top: 1px dashed ${COLORS.cirrus_black4};
    margin: 12px 0;
  `}
`;

export const HorizontalLine = styled.hr`
  width: 100%;
  margin: 4px 0;
  border: none;
  border-top: 1px dashed ${COLORS.cirrus_black4};
`;
